import React from 'react'
import Button from '../Button/Button'
import WhatsAppButton from '../Button/WhatsAppButton'

const PriceCard = ({
  title,
  validity,
  price,
  taxType,
  numberOfUser,
  buttonIcon: ButtonIcon,
  onClick
}) => {
  return (
    <div className='px-12 lg:px-14 py-4 border-2 border-blue-800 bg-blue-950 rounded-3xl z-10'>
      <div className='relative flex flex-col items-center gap-2'>

        <p className='w-fit text-center text-xs font-semibold uppercase rounded-full border-[1.5px] px-3 py-1 text-cyan-500 border-cyan-500 mt-4'>{title}</p>

        <p className='text-white opacity-80 font-semibold'>Validity : {validity}</p>

        <div className='text-white text-5xl font-semibold'>
          <span className='text-3xl pr-2'>INR</span>
          {price}
        </div>

        <p className='p'>{taxType}</p>
        <hr className='w-full my-4 border-slate-700' />
        <div className='flex flex-col gap-6 mb-8'>
          <p className='p'>{numberOfUser}</p>
        </div>

        {/* <Button icon={ButtonIcon} text='Buy Now' onClick={onClick} /> */}

        <WhatsAppButton text='WhatsApp' />
      </div>
    </div>
  )
}

export default PriceCard
